import {
  ALLOWED_TIMEZONE,
  NOTIFICATION_OPT_OUT_PREFERENCE_KEYS,
} from 'graphql-client/__generated/GeneratedEnumMaps';
import {AllowedTimezone} from 'graphql-client/__generated/graphqlGlobalTypes';
import preferences from 'Preferences';

const NOTIFICATION_DELIVERY_TIMEZONE_PREFERENCE = 'NOTIFICATION_DELIVERY_TIMEZONE';

export interface NotificationOptOutPreferences {
  isOptedOutOfProcesses: boolean;
  isOptedOutOfStudies: boolean;
  isOptedOutOfOrgs: boolean;
}

export function updateNotificationPreferences(
  notificationOptOutPreferences: NotificationOptOutPreferences,
  notificationDeliveryTimezonePreference: AllowedTimezone
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  return preferences.set({
    [NOTIFICATION_OPT_OUT_PREFERENCE_KEYS.PROCESSES_NOTIFICATION_OPT_OUT]:
      notificationOptOutPreferences.isOptedOutOfProcesses,
    [NOTIFICATION_OPT_OUT_PREFERENCE_KEYS.STUDIES_NOTIFICATION_OPT_OUT]:
      notificationOptOutPreferences.isOptedOutOfStudies,
    [NOTIFICATION_OPT_OUT_PREFERENCE_KEYS.ORG_NOTIFICATION_OPT_OUT]:
      notificationOptOutPreferences.isOptedOutOfOrgs,
    [NOTIFICATION_DELIVERY_TIMEZONE_PREFERENCE]: ALLOWED_TIMEZONE[notificationDeliveryTimezonePreference],
  });
}
